import React from "react";
const EmailIcon = () => <span className="material-icons text-[20px]">email</span>;
const AddressIcon = () => <span className="material-icons text-[20px]">location_on</span>;
const WebsiteIcon = () => <span className="material-icons text-[20px]">public</span>;


export default function TermsAndConditions() {
  return (
    <div className="border p-6 bg-[#F1F1F1] shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Terms and Conditions</h1>
          <p className="mt-2 text-[#777B7F]">
            Please read these terms carefully before using the Roott platform.
          </p>
        </div>
        

      </div>

      {/* Last Updated */}
      <div className="mt-6 p-4 bg-white rounded-lg shadow-sm">
        {/* <p className="text-sm text-[#777B7F]"> */}
          {/* <span className="font-semibold text-gray-800">Last Updated:</span> December 2024 */}
        {/* </p> */}
        <p className="text-sm text-[#777B7F] mt-2">
          By using Roott, you agree to these Terms of Service. If you have any questions, please contact us at{" "}
          <a href="mailto:team@roott.one" className="text-[#93C893] hover:underline">
            team@roott.one
          </a>
        </p>
      </div>

      {/* Terms Content */}
      <div className="mt-6 bg-white rounded-lg shadow-sm p-6">
        <div className="prose max-w-none text-[#777B7F] space-y-6">
          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">1. Acceptance of Terms</h2>
            <p>
              By creating an account, accessing, or using the Roott platform ("Service"), you agree to be bound by these Terms of Service ("Terms") and our Privacy Policy. If you do not agree, you must not use the Service.
            </p>
            <p>
              These Terms form a binding agreement between you ("User," "you") and Roott Ltd ("Roott," "we," "our," or "us"). If you have any questions about these Terms, please contact us at team@roott.one.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">2. Description of Service</h2>
            <p>
              Roott is an AI-powered software platform that helps individuals, charities, startups, and organizations discover and track grant and funding opportunities, manage application workflows, deadlines, and supporting documents, and use AI-driven tools to generate application drafts and improve submissions.
            </p>
            <p>
              Roott does not offer financial, legal, or tax advice. The platform provides organizational and productivity tools only, helping users manage information more effectively.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">3. Eligibility</h2>
            <p>
              To use Roott, you must be at least 18 years old, have the legal authority to enter into these Terms, and provide accurate and up-to-date information when registering. If you have questions about eligibility or account setup, please reach out to our team at team@roott.one.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">4. Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account. Please notify us immediately at team@roott.one if you suspect unauthorized access or any security breach.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">5. Subscription and Payments</h2>
            <p>
              Access to certain Roott features requires a paid subscription. Prices are displayed clearly at checkout and processed securely through our payment partners (such as Paddle, Stripe, or Lemon Squeezy). Subscriptions automatically renew unless cancelled before the renewal date. You may cancel at any time through your dashboard or by emailing us at team@roott.one.
            </p>
            <p>
              All payments are handled in compliance with UK consumer law. Refunds are only provided where legally required or explicitly stated in promotional offers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">6. Acceptable Use</h2>
            <p>
              You agree not to use Roott for unlawful or misleading activity, share or sell platform data without permission, attempt to copy, reverse engineer, or resell our technology, or upload malware, spam, or disruptive content.
            </p>
            <p>
              Roott reserves the right to suspend or terminate accounts violating these terms. For any misuse reports, contact our compliance team at team@roott.one.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">7. Intellectual Property</h2>
            <p>
              All software, content, and branding provided by Roott Ltd remain our exclusive property or that of our licensors. You are granted a limited, non-exclusive, non-transferable license to use the platform for your internal business or personal purposes.
            </p>
            <p>
              Any unauthorized copying or redistribution may result in account suspension or legal action.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">8. AI-Generated Content</h2>
            <p>
              Roott includes AI-based tools to generate text and recommendations. These are for informational and drafting purposes only. You are responsible for reviewing and editing all AI-generated content before submission. Roott is not liable for any inaccuracies or consequences resulting from AI outputs.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">9. Data and Privacy</h2>
            <p>
              Your data privacy is important to us. Roott collects and processes limited personal data to operate the Service, in accordance with the UK GDPR and Data Protection Act 2018. You can read our full Privacy Policy at www.roott.one/privacy.
            </p>
            <p>
              If you have privacy concerns or wish to exercise your rights, contact us at team@roott.one or by post at: Roott Ltd, 26 Waterside Court, Millpond Place, Carshalton, SM5 2JT, United Kingdom.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">10. Disclaimers</h2>
            <p>
              The Roott platform is provided "as is" and "as available." We do not guarantee any specific funding results or the accuracy of third-party information.
            </p>
            <p>
              While we aim to ensure reliable service, we cannot promise uninterrupted access, bug-free performance, or guaranteed funding outcomes.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">11. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Roott Ltd, its directors, and team members are not liable for indirect or consequential losses, including loss of profits, data, or opportunities. Our total liability for any claim will not exceed the total fees paid by you to Roott within the previous 12 months.
            </p>
            <p>
              If you believe you have experienced an issue with your account or billing, please contact us promptly at team@roott.one.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">12. Termination</h2>
            <p>
              You may close your account at any time through your dashboard or by emailing team@roott.one. We may suspend or terminate access if you violate these Terms, use the platform fraudulently or unlawfully, or if continued service poses regulatory or security risks.
            </p>
            <p>
              Upon termination, your access will end immediately, but essential data may be retained as required by law.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">13. Modifications</h2>
            <p>
              Roott may update these Terms from time to time to reflect changes in our service, policies, or legal requirements. The revised Terms will be posted at www.roott.one/terms and take effect upon publication.
            </p>
            <p>
              If you continue to use Roott after updates, it means you accept the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-3">14. Governing Law</h2>
            <p>
              These Terms are governed by and construed in accordance with the laws of England and Wales. Any disputes will be resolved exclusively in the courts of London, United Kingdom.
            </p>
          </section>

          <section>
    <h2 className="text-lg font-semibold text-gray-800 mb-3">15. Contact</h2>
    <p>For any questions, account help, or legal requests, please contact:</p>
    <p className="mt-2 space-y-1">
      <span className="flex items-center gap-2">
        <EmailIcon /><b> Email:</b>  <a
            href="mailto:team@roott.one">
                team@roott.one
            </a>
      </span>
      <span className="flex items-center gap-2">
        <AddressIcon /> <b>Address: </b>Roott Ltd, 26 Waterside Court, Millpond Place, Carshalton, SM5 2JT, United Kingdom
      </span>
      <span className="flex items-center gap-2">
        <WebsiteIcon /> <b>Website: </b>
        <a
            href="https://www.roott.one"
            target="_blank"
            rel="noopener noreferrer">www.roott.one</a>
      </span>
    </p>
  </section>
        </div>
      </div>

      {/* Footer Contact Section */}
      {/* <div className="mt-8 p-6 bg-white rounded-lg shadow-sm">
        <h3 className="text-lg font-semibold mb-4">Need Help?</h3>
        <p className="text-[#777B7F] mb-4">
          If you have any questions about these Terms and Conditions, please don't hesitate to reach out to our team.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href="mailto:team@roott.one"
            className="bg-[#93C893] px-6 py-2 rounded-lg hover:opacity-90 text-center"
          >
            Email Support
          </a>
          <a
            href="https://www.roott.one"
            target="_blank"
            rel="noopener noreferrer"
            className="border border-gray-300 px-6 py-2 rounded-lg hover:bg-gray-50 text-center"
          >
            Visit Website
          </a>
        </div>
      </div> */}
    </div>
  );
}